import App from "@/App";
import { SessionExpiredModal } from "@/components/auth/SessionExpiredModal";
import { AuthProvider } from "@/lib/auth";
import { maybeRedirectToCanisterLocalhost } from "@/lib/local-origin";
import { applyDocumentIcons } from "@/lib/public-url";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import "./index.css";

/**
 * Local: 127.0.0.1/?canisterId=X → http://X.localhost:8000/
 * Official asset-canister URL — absolute /assets/* (icons, JS) load correctly.
 */
if (maybeRedirectToCanisterLocalhost()) {
	// Navigation in progress
} else {
	applyDocumentIcons();
}

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

// If redirect fired, this still runs briefly before unload — acceptable.
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ThemeProvider attribute="class" defaultTheme="light" enableSystem>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<BrowserRouter>
						<App />
						<SessionExpiredModal />
						<Toaster
							richColors
							position="top-center"
							toastOptions={{
								classNames: {
									error:
										"!bg-red-950 !text-red-50 !border !border-red-700 !shadow-lg [&>div]:!opacity-100",
									success:
										"!bg-emerald-950 !text-emerald-50 !border !border-emerald-700",
								},
							}}
						/>
					</BrowserRouter>
				</AuthProvider>
			</QueryClientProvider>
		</ThemeProvider>
	</StrictMode>,
);
